import { render, staticRenderFns } from "./Shipper.vue?vue&type=template&id=1ff7cc71&scoped=true"
import script from "./Shipper.vue?vue&type=script&lang=js"
export * from "./Shipper.vue?vue&type=script&lang=js"
import style0 from "./Shipper.vue?vue&type=style&index=0&id=1ff7cc71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7cc71",
  null
  
)

export default component.exports